import { TouchSensor } from "@dnd-kit/core";
import { makeAutoObservable } from "mobx";

class Film {
  film = {};
  voiceovers = [];
  voiceoversEdit = []

  constructor() {
    makeAutoObservable(this);
  }

  setFilm(film) {
    this.film = film
  }
  
  setFilmOption(key:string, value:any) {
    this.film[key] = value;
  }

  addVoiceoversToEdit(voiceover) {
    this.voiceoversEdit.push(voiceover)
  }

  addToVoiceOvers(voiceover) {
    this.voiceovers.push(voiceover)
  }

  /**
   * Правка одной озвучки в списке.
   *
   * `target` — элемент списка, из которого открыли модалку: у новых озвучек
   * `id` не задан, и прежнее сравнение `item.id === voiceover.id` совпадало для
   * всех подряд (`undefined === undefined`) — правка одной карточки
   * перезаписывала остальные, а на сохранении вылезал дубль audio_track_index.
   */
  editVoiceOver(voiceover = null, target = null) {
    if(!voiceover) {
      return;
    }

    if(target) {
      const index = this.voiceovers.indexOf(target);

      if(index !== -1) {
        this.voiceovers[index] = {
          ...this.voiceovers[index],
          ...voiceover
        }

        return;
      }
    }

    this.voiceovers = this.voiceovers.map((item) => {
      // Сравниваем только определённые id — иначе правило срабатывает на всех новых
      if(item.id !== undefined && item.id === voiceover.id) {
        return {
          ...item,
          ...voiceover
        }
      }

      return item
    })
  }

  setVoiceover(list = []) {
    this.voiceovers = list;
  }

  removeVoiceOvers(index) {
    this.voiceovers.splice(index, 1)
  }

  clearVoiceovers() {
    this.voiceovers = []
  }

  get listVoiceovers() {
    return this.voiceovers || [];
  }

  get filmInfo() {
    return this.film
  }
}

export const filmStore = new Film();
